<style >
.sweet-modal{
    max-width: none;
}
.sweet-title{
    margin-top: 1.5%;
}
</style>
<template>
	<div class="vision_test_form" style="direction: ltr;">


		<!--span class="close-btn d-flex justify-content-end">
			<i class="material-icons">close</i>
		</span-->
        <b-button v-on:click="opendd()">{{$t('message.new_vision_test')}} <i class="zmdi zmdi-eye"></i></b-button>


        <div style="margin-top: 30px;">
            <virtual-list v-if="data_optics.vision_tests"
                class="list"
                style="height: 360px; overflow-y: auto;"
                :data-key="'id'"
                :data-sources="data_optics.vision_tests"
                :data-component="item"
                :estimate-size="50"
            />
        </div>
        
		<!--div class="d-flex align-center justify-content-center my-auto">
			<input type="text" v-model="search" required autocomplete="true" prepend-icon="search"
				placeholder="What are you looking for.." class="search-input" @click.stop="onClickSearch">
		</div-->


        <sweet-modal ref="new_vision_test" :title="$t('message.new_vision_test')">
    
		    <notifications group="popup" position="top center" animation-type="velocity" />

            <div class="row" style="display: block;">
                <div style="display: flex; flex-flow: row wrap;" class="">

                    <b-form-group style="flex:1 0 auto;margin: 1% 1%;" id="name" :label="$t('message.name')" label-for="name">
                        <b-alert show variant="secondary">
                                {{getUser.Accounts_to_user[getUser.accountselected].name}}
                        </b-alert>
                        
                    </b-form-group>
                    <b-form-group style="flex:1 0 auto;margin: 1% 1%;" id="famyly" :label="$t('message.famyly')" label-for="famyly">
                    <b-alert show variant="secondary">
                                {{getUser.Accounts_to_user[getUser.accountselected].famyly}}
                        </b-alert>
                        
                    </b-form-group>

                    <b-form-group style="flex:1 0 auto;margin: 1% 1%;" id="nick" :label="$t('message.nick')" label-for="nick">
                    <b-alert show variant="secondary">
                                {{getUser.Accounts_to_user[getUser.accountselected].nick}}
                        </b-alert>
                        
                    </b-form-group>
                    

                    <boxdropdown style="flex:1 0 auto;margin: 1% 1%;" :location="'form'" :input_placeholder="getUser.Accounts_to_user[getUser.accountselected].nick" :icon="'zmdi-accounts-list'">
                            <selectnick >
                                                                    
                            </selectnick>
                    </boxdropdown>


                    <b-form-group style="flex:1 0 auto;margin: 1% 1%;" id="nick" :label="$t('message.execution_time')" label-for="nick">
                        <b-input class="alert alert-secondary" v-model="data.execution_time" style="margin: 1% 1%;" id="thizInput" required
                            :value="data.execution_time" >
                        </b-input>
                    </b-form-group>
                    <boxdropdown style="flex:1 0 auto;margin: 1% 1%;" :location="'form'"  :icon="'zmdi-calendar-note'">
                        <b-col md="auto">
                            <b-calendar v-model="data.execution_time" locale="en-US"></b-calendar>
                        </b-col>
                        
                    </boxdropdown>
                        
                    <b-form-group style="flex:1 0 auto;margin: 1% 1%;" id="optometrist" :label="$t('message.optometrist')" label-for="optometrist">
                        <b-alert show variant="secondary">
                                {{data.optometrist}}
                        </b-alert>
                    </b-form-group>

                    

                    <boxdropdown style="flex:1 0 auto;margin: 1% 1%;" :location="'form'" :input_placeholder="getUser.Accounts_to_user[getUser.accountselected].nick" :icon="'zmdi-accounts-list'">
                            <selectnick >
                                                                    
                            </selectnick>
                    </boxdropdown>


                        
                </div>
                
            </div>

            <b-button v-on:click="fix_eye_test(data)">{{$t('message.fix')}}</b-button>

                       
        </sweet-modal>
	</div>

    
</template>



<script>
   
import { SweetModal } from 'sweet-modal-vue'

import selectnick from '@/components/Widgets/SelectNick'
import boxdropdown from '@/components/Widgets/BoxDropdown'

import { mapGetters } from "vuex";


import Item from '@/components/optics/Item';

//import Intersect from 'vue-intersect'

	export default {
        
        components: {
            SweetModal,
            selectnick,
            boxdropdown,
            Item,
            
	    },
        data() {
			return {
                data:{
                    
                    execution_time:'',
                    optometrist:'s',
                
                    

                },
                msg: [{title:'dd'} ,{title:'I will change'},{title:'גכגג'}],
                //items: data1,
                item:Item
			};
		},
        computed: {
            ...mapGetters({
                getUser: "getUser",
                data_optics: "optics/data_optics"
            })
        },
		methods: {
            opendd(){
                this.$refs['new_vision_test'].open()
            },
            fix_eye_test(data){
                //console.log(data)
                this.$store.dispatch("fix_eye_test", data);
            },
			
		}
	};
</script>

<style scoped>
#infinite-scroll {
  font-family: Verdana;
  font-size: 10pt;
  width: 85vw;
  max-width: 1280px;
  margin: 10px auto;
}

</style>